import PropTypes from "prop-types";

/**
 * Shared PropTypes definitions for PeriodRow components.
 * Eliminates duplication across oriolaPeriodRow, pharmacyPeriodRow, and pharmaCompanyPeriodRow.
 *
 * Usage:
 * import { periodRowBasePropTypes, periodRowBaseDefaultProps } from "../common/propTypes/periodRowPropTypes";
 *
 * ComponentName.propTypes = {
 *   ...periodRowBasePropTypes,
 *   // Add component-specific props here
 * };
 *
 * ComponentName.defaultProps = {
 *   ...periodRowBaseDefaultProps,
 *   // Add component-specific defaults here
 * };
 */

// Common period shape used across all PeriodRow components
export const periodShape = PropTypes.shape({
  periodStartDate: PropTypes.string.isRequired,
  periodEndDate: PropTypes.string.isRequired,
});

// Base PropTypes common to all PeriodRow components
export const periodRowBasePropTypes = {
  period: periodShape.isRequired,
  compensations: PropTypes.arrayOf(PropTypes.shape({})),
  fetching: PropTypes.bool,
  fetchError: PropTypes.node,
  preload: PropTypes.bool,
};

// Base default props common to all PeriodRow components
export const periodRowBaseDefaultProps = {
  compensations: null,
  fetching: false,
  fetchError: null,
  preload: false,
};

// Common profit centers prop used by multiple PeriodRow components
export const inServiceProfitCentersPropTypes = {
  inServiceProfitCenters: PropTypes.arrayOf(PropTypes.shape({})),
};

export const inServiceProfitCentersDefaultProps = {
  inServiceProfitCenters: null,
};
